import React from 'react';

interface Props {
    onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
    fallback: React.ComponentType<{ error?: Error }>;
}

interface State {
    error?: Error;
}

class ErrorBoundary extends React.Component<Props, State> {
    public readonly state: State = {};

    public static getDerivedStateFromError(error: Error): State {
        return { error };
    }

    public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        const { onError } = this.props;

        onError?.(error, errorInfo);
    }

    public render(): React.ReactNode {
        const { children, fallback: FallbackComponent } = this.props;

        const { error } = this.state;

        return error ? <FallbackComponent error={error} /> : children;
    }
}

export { ErrorBoundary };
